import React,{useState, useEffect} from "react";
import {Row, Col} from "react-bootstrap";
import axios from "axios";
import {useHistory} from "react-router-dom";
import HeaderInfluxs from "./headerInfluxs";

function ListOfActions() {

    const uriLastAction = "https://bo.influxs.live/StraKingAPI00X/api/last_actions";
    const [actionList, setActionList] = useState(null);
    let history=useHistory();
    useEffect(() => {
        const token = localStorage.getItem('token');
        const contraId = localStorage.getItem('contraId');
        console.log(contraId);
        const api = axios.create({
            baseURL: uriLastAction,
            headers: {'Authorization': 'Bearer ' + token}
        });

        getLastAction();


        async function getLastAction() {
            api.get(uriLastAction+"/"+contraId).then(
                res => {
                    console.log(res);
                    setActionList(res.data);
                }
            ).catch(err => {

                alert(err.response.data.message);
            })

        }
    }, []);

    return (
        <div className="listOfAction">
            <HeaderInfluxs/>
            <div className="list-of-contra-header">
                <Row>
                    <Col>
                        <div>Les dernières actions</div>
                    </Col>

                    <Col>
                        <div className="form-inner">
                            <div className="form-group">
                                <input type="search"
                                       className="input"
                                       placeholder="Recherche"/>
                            </div>
                        </div>
                    </Col>
                    <Col className="buttonCreateAction">
                        <button className="button" onClick={() => {
                            history.push('/contraDetails');
                        }}>Retour</button>
                    </Col>
                    <Col className="buttonCreateAction">
                        <button className="button" onClick={() => {
                            history.push('/createAction');
                        }}>Créer une action</button>
                    </Col>

                </Row>
                {actionList && actionList.length > 0 ?  (
                    <div className="contra">
                        {actionList.map((contr, index) => (
                            <div key={index} onClick={() => {
                                localStorage.setItem('actionId', contr.id);
                                history.push('/actionDetails');
                            }}>
                                <div className="UserInfo">
                                    <li className="list-of-action">
                                        {/*<span><img className="icon"*/}
                                        {/*           src={contr.image}*/}
                                        {/*           alt=""/></span>*/}
                                        <span>Titre de l'action: {contr.text} <br/>
                                        <span>Type de publication: {contr.type}</span><br/>
                                        <span>Platforme: {contr.platform}</span><br/>
                                        <span>Date de publication: {contr.date_j}</span><br/>
                                    </span>
                                        <span>
                                        <button className="button" onClick={() => {
                                            localStorage.setItem('actionId', contr.id);
                                            history.push('/actionDetails');
                                        }}>voir plus</button>
                                    </span>

                                    </li>
                                </div>
                            </div>

                        ))}

                    </div>
                ) : <h1>...</h1>}
            </div>
        </div>
    )
}

export default ListOfActions;